export default {
    'jpg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'svg': 'image/svg+xml',
    'psd': 'image/photoshop'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-image-crop-upload/utils/mimes.js
// module id = 626
// module chunks = 3